import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function MetricContent(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-gray-30 py-10 px-6 md:px-14 md:mb-20"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:flex lg:gap-x-9"
    }, props.statisticNumber ? /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-1/4 relative blue-angle-lg pt-12 md:pt-14 lg:pt-20 pr-5"
    }, /*#__PURE__*/ React.createElement("div", {
        className: 'md:text-center lg:text-left mb-14 lg:mb-0 before:content-[""] before:block before:w-0.5 before:bg-blue-200 before:absolute before:top-[115px] before:right-0 before:h-[calc(100%-80px)] before:md:h-[calc(100%-122px)] before:lg:h-[calc(100%-75px)]'
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block mb-1 md:mb-3 break-all leading-none text-[60px] md:text-[78px] xl:text-[84px] font-semibold font-heading text-blue-500"
    }, props.statisticNumber), /*#__PURE__*/ React.createElement("span", {
        className: "block font-medium text-gray-100"
    }, props.statText))) : null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("lg:w-3/4 mt-16 lg:mt-8 overflow-hidden", {
            "mx-auto": !props.statisticNumber
        })
    }, props.section.map(function(section, key) {
        return /*#__PURE__*/ React.createElement("div", {
            key: key,
            className: "border-b-2 border-gray-400 last:border-0 mb-14 md:mb-6 pb-1 lg:pb-6 last:mb-0"
        }, /*#__PURE__*/ React.createElement(MetricContentSection, section));
    }))), /*#__PURE__*/ React.createElement("svg", {
        className: "absolute top-72 -left-14 knime-hidden lg:block",
        xmlns: "http://www.w3.org/2000/svg",
        width: "146px",
        height: "531px",
        viewBox: "0 0 146 531",
        version: "1.1"
    }, /*#__PURE__*/ React.createElement("title", null, "Bit Cluster/Yellow"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Product-Detail-Page:-Analytics-Platform",
        transform: "translate(-9.000000, -1773.000000)",
        fill: "#D0ECEF"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Product-Features",
        transform: "translate(-23.000000, 473.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Section/Features",
        transform: "translate(0.000000, 1028.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Bit-Cluster/Yellow",
        transform: "translate(89.000000, 537.178261) rotate(-270.000000) translate(-89.000000, -537.178261) translate(-176.000000, 448.178261)"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 73.000000) rotate(-360.000000) translate(-457.000000, -73.000000) ",
        x: "448",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(393.000000, 73.000000) rotate(-360.000000) translate(-393.000000, -73.000000) ",
        x: "384",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(329.000000, 73.000000) rotate(-360.000000) translate(-329.000000, -73.000000) ",
        x: "320",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 73.000000) rotate(-360.000000) translate(-265.000000, -73.000000) ",
        x: "256",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 73.000000) rotate(-360.000000) translate(-169.000000, -73.000000) ",
        x: "160",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(105.000000, 73.000000) rotate(-360.000000) translate(-105.000000, -73.000000) ",
        x: "96",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 73.000000) rotate(-360.000000) translate(-73.000000, -73.000000) ",
        x: "64",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(41.000000, 73.000000) rotate(-360.000000) translate(-41.000000, -73.000000) ",
        x: "32",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 105.000000) rotate(-360.000000) translate(-457.000000, -105.000000) ",
        x: "448",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 105.000000) rotate(-360.000000) translate(-425.000000, -105.000000) ",
        x: "416",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(361.000000, 105.000000) rotate(-360.000000) translate(-361.000000, -105.000000) ",
        x: "352",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 105.000000) rotate(-360.000000) translate(-297.000000, -105.000000) ",
        x: "288",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 105.000000) rotate(-360.000000) translate(-201.000000, -105.000000) ",
        x: "192",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 105.000000) rotate(-360.000000) translate(-169.000000, -105.000000) ",
        x: "160",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 105.000000) rotate(-360.000000) translate(-137.000000, -105.000000) ",
        x: "128",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 105.000000) rotate(-360.000000) translate(-73.000000, -105.000000) ",
        x: "64",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(521.000000, 137.000000) rotate(-360.000000) translate(-521.000000, -137.000000) ",
        x: "512",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(489.000000, 137.000000) rotate(-360.000000) translate(-489.000000, -137.000000) ",
        x: "480",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 137.000000) rotate(-360.000000) translate(-425.000000, -137.000000) ",
        x: "416",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(329.000000, 137.000000) rotate(-360.000000) translate(-329.000000, -137.000000) ",
        x: "320",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 137.000000) rotate(-360.000000) translate(-297.000000, -137.000000) ",
        x: "288",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 137.000000) rotate(-360.000000) translate(-201.000000, -137.000000) ",
        x: "192",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(521.000000, 169.000000) rotate(-360.000000) translate(-521.000000, -169.000000) ",
        x: "512",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(457.000000, 169.000000) rotate(-360.000000) translate(-457.000000, -169.000000) ",
        x: "448",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(393.000000, 169.000000) rotate(-360.000000) translate(-393.000000, -169.000000) ",
        x: "384",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 9.000000) rotate(-360.000000) translate(-425.000000, -9.000000) ",
        x: "416",
        y: "2.43065927e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 9.000000) rotate(-360.000000) translate(-297.000000, -9.000000) ",
        x: "288",
        y: "1.81314017e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 9.000000) rotate(-360.000000) translate(-265.000000, -9.000000) ",
        x: "256",
        y: "1.87192322e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 9.000000) rotate(-360.000000) translate(-201.000000, -9.000000) ",
        x: "192",
        y: "1.70527222e-13",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(9.000000, 9.000000) rotate(-360.000000) translate(-9.000000, -9.000000) ",
        x: "-5.68434189e-14",
        y: "-2.1576626e-14",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(425.000000, 41.000000) rotate(-360.000000) translate(-425.000000, -41.000000) ",
        x: "416",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(361.000000, 41.000000) rotate(-360.000000) translate(-361.000000, -41.000000) ",
        x: "352",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 41.000000) rotate(-360.000000) translate(-265.000000, -41.000000) ",
        x: "256",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(233.000000, 41.000000) rotate(-360.000000) translate(-233.000000, -41.000000) ",
        x: "224",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 41.000000) rotate(-360.000000) translate(-169.000000, -41.000000) ",
        x: "160",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 41.000000) rotate(-360.000000) translate(-137.000000, -41.000000) ",
        x: "128",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 41.000000) rotate(-360.000000) translate(-73.000000, -41.000000) ",
        x: "64",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(9.000000, 41.000000) rotate(-360.000000) translate(-9.000000, -41.000000) ",
        x: "0",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    })))))))));
}
function MetricContentSection(param) {
    var image = param.image, heading = param.heading, content = param.content, sectionLink = param.sectionLink;
    return /*#__PURE__*/ React.createElement("div", {
        className: "md:flex w-full md:gap-x-8 xl:items-center mb-4 md:mb-0"
    }, image && /*#__PURE__*/ React.createElement("div", {
        className: "max-[767px]:mx-auto mb-6 lg:m-0 w-[190px] shrink-0"
    }, /*#__PURE__*/ React.createElement("img", {
        width: "190",
        src: "".concat(image),
        alt: "".concat(heading),
        className: "mx-auto md:m-0 w-full"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "mb-3 lg:mb-0"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-xl md:text-2xl lg:text-[1.7rem] font-semibold mt-8 mb-4 md:mt-0"
    }, heading), content ? /*#__PURE__*/ React.createElement("div", {
        className: "text-[0.85rem] content-text content-text-sm"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: content
    })) : null, sectionLink ? /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, /*#__PURE__*/ React.createElement(ArrowLink, {
        text: sectionLink.label,
        target: sectionLink.target
    })) : null));
}
